import { Avatar } from '@chakra-ui/react'
import { useAuthedSrc } from '../../hooks/useAuthedSrc'

type AuthedAvatarImageProps = Omit<Avatar.ImageProps, 'src'> & { src?: string | null }

/**
 * [Native B1] `Avatar.Image` for an authenticated portrait URL (`/api/.../portrait`). Web: the
 * url as-is (cookie auth). Native: a blob URL fetched with the bearer (`useAuthedSrc`). A hook
 * cannot be called inside a `.map`, so list rows render this instead of `Avatar.Image` directly.
 */
export function AuthedAvatarImage({ src, ...rest }: AuthedAvatarImageProps) {
  return <Avatar.Image src={useAuthedSrc(src)} {...rest} />
}
